import * as Sentry from '@sentry/react'

import { api } from './_init'

const languageMap = Object.freeze({
  en: 'English',
  de: 'German',
  fr: 'French',
  pt: 'European Portuguese',
  cs: 'Czech',
  hr: 'Croatian',
  fi: 'Finnish',
  sv: 'Swedish',
  da: 'Danish',
  no: 'Norwegian',
  es: 'Spanish',
  it: 'Italian',
  nl: 'Dutch',
  pl: 'Polish',
})

export async function fetchGeneratedCreativesAsync(
  {
    eventId,
    tc,
    tcRunId,
    creativeFieldName,
    language,
    requiredNumberOfCreatives = 3,
    platforms,
    campaignType,
  },
  controller = null,
) {
  const params = {
    event_id: eventId,
    tc,
    tc_run_id: tcRunId,
    creatives_type: creativeFieldName,
    required_number_of_creatives: requiredNumberOfCreatives,
    language: languageMap[language],
  }

  // Add platforms if provided (backend expects 'google' and 'meta')
  // Map 'fb' to 'meta' for backend compatibility
  if (platforms && platforms.length > 0) {
    params.platforms = platforms.map((platform) => (platform === 'fb' ? 'meta' : platform))
  }

  // Add campaign_type if provided (e.g., 'DISPLAY', 'VIDEO_CONVERSIONS')
  if (campaignType) {
    params.campaign_type = campaignType
  }

  try {
    const result = await api.get('/integrations/openai/gpt-4o/generate_creatives', {
      params,
      signal: controller?.signal,
      // Flask's reqparse with action="append" expects repeated params without brackets
      paramsSerializer: (params) => {
        const searchParams = new URLSearchParams()
        Object.entries(params).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            value.forEach((item) => searchParams.append(key, item))
          } else if (value !== undefined && value !== null) {
            searchParams.append(key, value)
          }
        })
        return searchParams.toString()
      },
    })

    return {
      results: result.data,
      success: result.status === 200,
    }
  } catch (e) {
    Sentry.captureException(e)
    return { success: false }
  }
}
